// Google Consent Mode v2 helper. Default = denied (RGPD), updated on user choice.
// Supports granular consent: analytics_storage vs ad_storage handled independently.
import { store } from "./storage";

const KEY = "smarti_cookie_consent";
const CID_KEY = "smarti_consent_id";

const DENIED = { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" };

// Reopen the cookie preferences modal from anywhere (e.g. a "Gérer les cookies" link).
export function openCookiePreferences() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event("open-cookie-preferences"));
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

// Build a Consent Mode v2 payload from granular booleans.
function payload({ analytics, ads }) {
  const a = analytics ? "granted" : "denied";
  const m = ads ? "granted" : "denied";
  return { ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: a };
}

// Reads the stored choice and normalizes it to { analytics, ads } booleans.
export function readConsent() {
  try {
    const stored = JSON.parse(store.get(KEY) || "null");
    if (!stored) return null;
    if (typeof stored.analytics === "boolean" || typeof stored.ads === "boolean") {
      return { analytics: !!stored.analytics, ads: !!stored.ads };
    }
    // Backward compatibility with the old { value: "accepted" | "refused" } format.
    if (stored.value === "accepted") return { analytics: true, ads: true };
    if (stored.value === "refused") return { analytics: false, ads: false };
  } catch (e) { /* ignore */ }
  return null;
}

// Set the default (denied) consent BEFORE any tag loads, then apply a prior choice if any.
export function initConsent() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || gtag;
  window.gtag("consent", "default", { ...DENIED, wait_for_update: 500 });
  const prior = readConsent();
  if (prior) window.gtag("consent", "update", payload(prior));
}

// Persist and dispatch a granular consent choice to the dataLayer + server (proof of consent).
export function setConsent({ analytics, ads }) {
  if (typeof window === "undefined") return;
  window.gtag = window.gtag || gtag;
  store.set(KEY, JSON.stringify({ analytics: !!analytics, ads: !!ads, at: new Date().toISOString() }));
  window.gtag("consent", "update", payload({ analytics, ads }));
  // Record the consent server-side (non-blocking) for RGPD proof.
  try {
    const url = process.env.REACT_APP_BACKEND_URL;
    if (url) {
      const cid = store.get(CID_KEY) || undefined;
      fetch(`${url}/api/consent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ analytics: !!analytics, ads: !!ads, id: cid }),
        keepalive: true,
      })
        .then((r) => r.json())
        .then((d) => { if (d && d.id) store.set(CID_KEY, d.id); })
        .catch(() => {});
    }
  } catch (e) { /* ignore */ }
}
